import { Injectable } from '@angular/core';
import { AddressComponentKind } from '../models/map.models';
import { ICoordinates } from '../models/organizationInfo/deliveryTerminal/deliveryZone.model';
import { Point } from '../pages/delivery-address/shared/map/map.models';
import { OrganizationsService } from './organizations.service';
import { map, Observable } from 'rxjs';
import { DeliveryAddress } from '../models/address';
import { DeliveryType } from 'app/models/user-order.model';

export interface GeocodeResult {
  GeoObjectCollection: {
    featureMember: {
      GeoObject: {
        Point: {
          pos: string
        },
        metaDataProperty: {
          GeocoderMetaData: {
            Address: {
              Components: {
                kind: AddressComponentKind,
                name: string
              }[]
            },
            text: string
            precision: string
          }
        },
        properties: {}
      }
    }[]
  };
}

@Injectable({
  providedIn: 'root'
})
export class YaMapsService {

  constructor(
    private organizationService: OrganizationsService
  ) {
  }

  public static pointInsideZone(point: Point, zone: ICoordinates[]): boolean {
    // ray-casting algorithm based on
    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

    const x = point.lat;
    const y = point.lng;

    let inside = false;
    for (let i = 0, j = zone.length - 1; i < zone.length; j = i++) {
      const xi = zone[i].latitude;
      const yi = zone[i].longitude;
      const xj = zone[j].latitude;
      const yj = zone[j].longitude;

      const intersect = ((yi > y) !== (yj > y))
        && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) {
        inside = !inside;
      }
    }

    return inside;
  }

  public convertToDeliveryAddress(geocodeResult: GeocodeResult): Observable<DeliveryAddress> {
    const geoObject = geocodeResult.GeoObjectCollection.featureMember[0].GeoObject;
    const pointArray = geoObject.Point.pos.split(' ');
    const point: Point = {
      lat: parseFloat(pointArray[1]),
      lng: parseFloat(pointArray[0]),
    }

    return this.organizationService.getTerminalByPoint('', point)
      .pipe(
        map(deliveryTerminal => {
          const resultAddress: DeliveryAddress = {
            id: '',
            addressId: null,
            name: '',
            type: DeliveryType.DELIVERY,
            deliveryPoint: {
              country: '',
              region: '',
              city: '',
              street: '',
              house: '',
              apartment: '',
              description: '',
              latitude: point.lat,
              longitude: point.lng,
            },
            deliveryTerminal: deliveryTerminal
          };

          geoObject.metaDataProperty.GeocoderMetaData.Address.Components
            .forEach((item) => {
              switch (item.kind) {
                case 'country':
                  resultAddress.deliveryPoint.country = item.name;
                  break;
                case 'province':
                  resultAddress.deliveryPoint.region = item.name;
                  break;
                case 'locality':
                  resultAddress.deliveryPoint.city = item.name;
                  break;
                case 'street':
                  resultAddress.deliveryPoint.street = item.name;
                  break;
                case 'house':
                  resultAddress.deliveryPoint.house = item.name;
                  break;
                case 'entrance':
                  resultAddress.deliveryPoint.description = item.name;
                  break;
              }
            });
          return resultAddress;
        })
      );
  }
}
